<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="缺货商品详情"
    width="900px"
    :close-on-click-modal="false"
  >
    <div class="detail-wrapper">
      <el-row :gutter="16" class="detail-header">
        <el-col :span="5" style="display: flex;">
          <div style="width: auto;">商品编码：</div>
          <remark :content="rowData.goodsCode" style="white-space: nowrap; flex: 1; width: 0;" />
        </el-col>
        <el-col :span="7" style="display: flex;">
          <div style="width: auto;">商品名称：</div>
          <remark :content="rowData.goodsName" style="white-space: nowrap; flex: 1; width: 0;" />
        </el-col>
        <el-col :span="6" style="display: flex;">
          <div style="width: auto;">订单最晚发货时间：</div>
          <remark :content="latestDeliveryTime" style="white-space: nowrap; flex: 1; width: 0;" />
        </el-col>
        <el-col :span="6" style="display: flex;">
          <div style="width: auto;">本周预计出货时间：</div>
          <remark :content="rowData.shipmentTime" style="white-space: nowrap; flex: 1; width: 0;" />
        </el-col>
      </el-row>

      <el-table
        :data="tableData"
        border
        size="mini"
        height="360"
        v-loading="loading"
        :header-cell-style="{ backgroundColor: '#F4F8FB', textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column prop="productCode" label="产品编码" min-width="120" show-overflow-tooltip />
        <el-table-column prop="productName" label="产品名称" min-width="150" show-overflow-tooltip />
        <el-table-column prop="packCode" label="包件编码" min-width="120" show-overflow-tooltip />
        <el-table-column prop="packName" label="包件名称" min-width="150" show-overflow-tooltip />
        <el-table-column label="缺货状态" min-width="90">
          <template slot-scope="{ row }">
            <span :class="{ 'oos-status-text': isOutOfStock(row) }">
              {{ isOutOfStock(row) ? '缺货' : '不缺货' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="commonTag" label="通用件标识" min-width="90" />
        <el-table-column prop="shortageQty" label="缺货量" min-width="90" />
        <el-table-column prop="shipmentTime" label="预计出货时间" min-width="140" show-overflow-tooltip />
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import remark from '@/components/remark/remark.vue'

export default {
  components: { remark },
  name: 'GoodsDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      tableData: []
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    },
    latestDeliveryTime () {
      return this.rowData.latestShippingTime || '-'
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler (val) {
        if (val) {
          this.queryDetail()
        }
      }
    }
  },
  methods: {
    isOutOfStock (row) {
      if (row.shortageQty !== undefined && row.shortageQty !== null && row.shortageQty !== '') {
        const shortageQty = Number(row.shortageQty)
        if (!Number.isNaN(shortageQty)) {
          return shortageQty > 0
        }
      }

      if (typeof row.oosStatus === 'boolean') {
        return row.oosStatus
      }

      if (typeof row.oosStatus === 'number') {
        return row.oosStatus > 0
      }

      if (typeof row.oosStatus === 'string') {
        if (row.oosStatus.includes('不缺货')) {
          return false
        }
        if (row.oosStatus.includes('缺货')) {
          return true
        }
      }

      return false
    },
    queryDetail () {
      if (!this.rowData.goodsCode || !this.rowData.orderNo) {
        this.tableData = []
        return
      }
      this.loading = true
      this.$q.orderDate.deliveryOrderGoodsDetail({
        params: {
          goodsCode: this.rowData.goodsCode,
          orderNo: this.rowData.orderNo
        }
      }).then((res) => {
        this.tableData = res.success && Array.isArray(res.data) ? res.data : []
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.detail-header
  margin-bottom 12px
  color #303133
  line-height 20px

.oos-status-text
  color #f56c6c
</style>
